import { render, staticRenderFns } from "./OfficerForm.vue?vue&type=template&id=523fd8b0&scoped=true&"
import script from "./OfficerForm.vue?vue&type=script&lang=js&"
export * from "./OfficerForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficerForm.vue?vue&type=style&index=0&id=523fd8b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523fd8b0",
  null
  
)

export default component.exports